import React, { useEffect, useState } from 'react'
import { useApolloClient } from 'react-apollo'

import { getWindow, useEnv } from '@acorns/web-utils'

import { SessionAutoRefresh } from 'components/SessionAutoRefresh'
import { SessionTimer } from 'components/SessionTimer'
import { buildSignInUrl } from 'utils/authentication/buildSignInUrl'
import { isAuthenticated, refreshSessionCookies } from 'utils/session'

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const apolloClient = useApolloClient()
  const { env } = useEnv()

  const loginUrl = env.get('loginUrl')

  const [
    sessionRefreshOnAppLoadCompleted,
    setSessionRefreshOnAppLoadCompleted,
  ] = useState(false)

  useEffect(
    function refreshSessionOnAppLoad() {
      if (isAuthenticated()) {
        refreshSessionCookies(apolloClient).then(() => {
          setSessionRefreshOnAppLoadCompleted(true)
        })
      } else {
        getWindow().location.assign(
          buildSignInUrl(loginUrl, getWindow().location.href),
        )
      }
    },
    [apolloClient, loginUrl],
  )

  useEffect(
    function checkAuthStatusOnPageVisibilityChange() {
      window.document.addEventListener('visibilitychange', () => {
        if (
          window.document.visibilityState === 'visible' &&
          !isAuthenticated()
        ) {
          getWindow().location.assign('/')
        }
      })
    },
    [loginUrl],
  )

  if (sessionRefreshOnAppLoadCompleted) {
    return (
      <>
        <SessionAutoRefresh />
        <SessionTimer />
        {children}
      </>
    )
  }

  return null
}
